import React from "react";
import "./Footer.css";
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  WhatsappIcon,
  YoutubeIcon,
} from "../icons";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-section">
        <div className="socials">
          <a href="https://www.facebook.com/COLlive">
            <FacebookIcon size={30} fill={"white"} />
          </a>
          <a href="https://twitter.com/COLLiveNews">
            <TwitterIcon size={30} fill={"white"} />
          </a>
          <a href="https://www.instagram.com/colliveofficial">
            <InstagramIcon size={30} fill={"white"} />
          </a>
          <a href="https://api.whatsapp.com/send?phone=17186799450&text=I%20would%20like%20to%20sign%20up%20for%20news%20and%20updates%20from%20COLlive.com">
            <WhatsappIcon size={30} fill={"white"} />
          </a>
          <a href="https://www.youtube.com/user/COLlivedotcom">
            <YoutubeIcon size={30} fill={"white"} />
          </a>
        </div>
        <div class="copyright-text">
          © 2022 COL &amp; COLlive.com <br />- All Rights Reserved
          <br />
          <br />
          COLlive Is an independently run Orthodox Jewish news Service.
        </div>
      </div>
      <div className="footer-section mobile">
        <div className="footer-header">ABOUT US</div>
        <a href="https://collive.com/contact-us/" className="footer-link">
          Contact Us
        </a>
        <a
          href="https://collive.com/advertise-with-us/"
          className="footer-link"
        >
          Advertise With Us
        </a>
        <a href="https://collive.com/privacy-policy/" className="footer-link">
          Privacy Policy
        </a>
        <a href="https://collive.com/about" className="footer-link">
          About
        </a>
        <a
          href="https://collive.com/newsletter-subscribe/"
          className="footer-link"
        >
          Subscribe To Our Newsletters
        </a>
      </div>
      <div className="footer-section mobile">
        <div className="footer-header">IMPORTANT LINKS</div>
        <a href="https://collive.com/submit-news/" className="footer-link">
          Submit News
        </a>
        <a href="https://collive.com/submit-mazel-tov/" className="footer-link">
          Submit Mazel Tov
        </a>
        <a href="https://collive.com/add-new-event/" className="footer-link">
          Add New Event
        </a>
        <a
          href="https://collive.com/classifieds/post-a-classified/"
          className="footer-link"
        >
          Post a Classified
        </a>
        <a href="http://gegent.com/" className="footer-link">
          Business Listings
        </a>
        <a
          href="https://www.gegent.com/submit-a-listing/"
          className="footer-link"
        >
          Submit a Gegent Listing
        </a>
        <a href="https://gegent.com/" className="footer-link">
          <img
            src="https://collive.com/wp-content/uploads/2018/12/Top-logo-45-2.png"
            width={""}
            alt="COLlive"
          />
        </a>
      </div>
      <div className="footer-section mobile">
        <div className="footer-header">MEMBERS</div>
        <a href="https://collive.com/account/" className="footer-link">
          Account
        </a>
        <a href="https://collive.com/register/" className="footer-link">
          Register
        </a>
        <a href="https://collive.com/login/" className="footer-link">
          Login
        </a>
      </div>
      <div className="footer-section mobile active">
        <div className="socials">
          <a href="https://www.facebook.com/COLlive">
            <FacebookIcon size={30} fill={"white"} />
          </a>
          <a href="https://twitter.com/COLLiveNews">
            <TwitterIcon size={30} fill={"white"} />
          </a>
          <a href="https://www.instagram.com/colliveofficial">
            <InstagramIcon size={30} fill={"white"} />
          </a>
          <a href="https://api.whatsapp.com/send?phone=17186799450&text=I%20would%20like%20to%20sign%20up%20for%20news%20and%20updates%20from%20COLlive.com">
            <WhatsappIcon size={30} fill={"white"} />
          </a>
          <a href="https://www.youtube.com/user/COLlivedotcom">
            <YoutubeIcon size={30} fill={"white"} />
          </a>
        </div>
        <div class="copyright-text">
          © 2022 COL &amp; COLlive.com <br />- All Rights Reserved
          <br />
          <br />
          COLlive Is an independently run Orthodox Jewish news Service.
        </div>
      </div>
    </footer>
  );
};

export default Footer;

